module.exports = __webpack_public_path__ + "althash-health/static/img/help_patientcreate_3.28488d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help_patientcreate_3.png
// module id = LV++
// module chunks = 1